import {useTranslation} from "react-i18next";
import AboutBox from "./AboutBox";
import Bar from "components/Bar";

import bg from 'assets/images/home/main02.png';
import img1 from 'assets/images/home/main2-1.png';
import img2 from 'assets/images/home/main2-2.png';
import img3 from 'assets/images/home/main2-3.png';

export default function About(props){
  const {t} =  useTranslation();
  const imgs = [img1, img2, img3];
  const list = [];
  for(let i = 1; i < 4; i++){
    const title = t(`home.about.title-${i}`)
    const comment = t(`home.about.comment-${i}`)
    const obj = {alt:title, title, comment};
    list.push(obj);
  }

  return (
    <div className="flex justify-center bg" style={{backgroundImage:`url(${bg})`}}>
    <div className={`flex flex-col py-10 lg:py-[80px] px-mobile`}>
      <div className="flex flex-col mb-10 lg:flex-row">
        <p className="text-3xl font-normal tracking-wide text-white lg:text-5xl lg:basis-1/3">{t('home.about.main-title')}</p>
        <div className="lg:basis-2/3">
          <Bar width="47px"/>
          <p key="comment" className="mt-4 text-xs font-light text-white lg:text-base"
            dangerouslySetInnerHTML={{__html:t('home.about.main-comment')}}>
          </p>
        </div>
      </div>
      {/* PC View */}
      <div className="hidden lg:flex lg:flex-row lg:justify-center">
      {
        list.map((i ,index) => 
          <AboutBox key={i.title} image={imgs[index]} {...i} index={index}/>
        )
      }
      </div>
      {/* Mobile View */}
      <div className="lg:hidden">
        <div className="">
        {list.map((i, index) => {
          return (
            <AboutBox key={i.title} image={imgs[index]} {...i}/>
          );
          }
        )}
        </div>
      </div>
    </div>
    </div>
  );
}